// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-df779152] .form-label-container .form-label{padding-left:.47rem}[data-v-df779152] .ivu-tooltip{text-transform:none}", ""]);
// Exports
module.exports = exports;
